import * as React from "react"
import { getStudentDashboard } from "../auth/api"
import UserProfileDetails from "../components/UserProfileDetails"
import EditProfileModal from "../components/EditProfileModal"
import ChangePasswordModal from "../components/ChangePasswordModal"
import ProfilePhotoModal from "../components/ProfilePhotoModal"
import Avatar from "../components/Avatar"
import StudentAttendanceSection from "../components/StudentAttendanceSection"

export default function StudentDashboard({ user, onLogout }) {
  const [data, setData] = React.useState(null)
  const [error, setError] = React.useState("")
  const [showEditProfile, setShowEditProfile] = React.useState(false)
  const [showChangePassword, setShowChangePassword] = React.useState(false)
  const [showProfilePhoto, setShowProfilePhoto] = React.useState(false)

  React.useEffect(() => {
    let mounted = true
    async function load() {
      try {
        const res = await getStudentDashboard()
        if (mounted) setData(res)
      } catch (err) {
        if (mounted) setError(err?.message || "Erro ao carregar dados.")
      }
    }
    load()
    return () => {
      mounted = false
    }
  }, [])

  const profile = data?.profile || user

  function handleProfileSaved(updatedProfile) {
    setData((prev) => ({ ...prev, profile: updatedProfile }))
  }

  return (
    <div className="min-h-screen w-full bg-[#00072D] text-cor-base font-semi-bold font-oswald py-6 px-4 sm:px-6 overflow-y-auto">
      <div className="w-full max-w-3xl mx-auto space-y-6">
        <div className="bg-slate-50 backdrop-blur rounded-2xl p-4 sm:p-6 shadow-2xl">
          <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
            <div>
              <h1 className="text-2xl sm:text-3xl font-semibold">Área do Aluno</h1>
              <p className="text-slate-950 mt-1">
                Bem vindo(a), {profile?.nomeCompleto || user?.email}
              </p>
            </div>
            <button
              onClick={onLogout}
              className="shrink-0 self-start text-sm px-4 py-2 rounded-lg bg-cor-base text-slate-100 font-semibold active:scale-[.94] active:duration-75 transition-all hover:scale-[1.05]"
              type="button">
              Sair
            </button>
          </div>

          <div className="mt-6 flex justify-center">
            <Avatar src={profile?.fotoPerfilUrl} size="lg" />
          </div>

          <div className="mt-6 text-slate-950">
            {error ? (
              <div className="text-red-700">{error}</div>
            ) : profile ? (
              <UserProfileDetails profile={profile} />
            ) : (
              <div className="text-slate-950">Carregando dados...</div>
            )}
          </div>

          <div className="flex flex-wrap justify-end gap-3 mt-4">
            <button
              onClick={() =>
                window.open("https://intranetfsakm.com.br", "_blank")
              }
              className="px-4 py-2 rounded-lg bg-cor-base text-slate-100 font-semibold active:scale-[.94] active:duration-75 transition-all hover:scale-[1.05]"
              type="button">
              Marcar exame
            </button>
            <button
              onClick={() => setShowProfilePhoto(true)}
              className="px-4 py-2 rounded-lg bg-cor-base text-slate-100 font-semibold active:scale-[.94] active:duration-75 transition-all hover:scale-[1.05]"
              type="button">
              Perfil
            </button>
            <button
              onClick={() => setShowEditProfile(true)}
              className="px-4 py-2 rounded-lg bg-cor-base text-slate-100 font-semibold active:scale-[.94] active:duration-75 transition-all hover:scale-[1.05]"
              type="button">
              Alterar dados
            </button>
            <button
              onClick={() => setShowChangePassword(true)}
              className="px-4 py-2 rounded-lg border-2 border-cor-base text-cor-base font-semibold active:scale-[.94] active:duration-75 transition-all hover:scale-[1.05]"
              type="button">
              Alterar senha
            </button>
          </div>
        </div>

        <StudentAttendanceSection />
      </div>

      {showEditProfile && (
        <EditProfileModal
          profile={profile}
          onClose={() => setShowEditProfile(false)}
          onSaved={handleProfileSaved}
        />
      )}

      {showChangePassword && (
        <ChangePasswordModal onClose={() => setShowChangePassword(false)} />
      )}

      {showProfilePhoto && (
        <ProfilePhotoModal
          profile={profile}
          onClose={() => setShowProfilePhoto(false)}
          onSaved={handleProfileSaved}
        />
      )}
    </div>
  )
}
